<template>
  <div id="referrals-page">
    <PageTitle title="Referrals" />

    <b-container>
      <b-row align-v="stretch">
        <b-col cols="12" md="12" class="mb-4" style="z-index:10">
          <div class="wrapper p-4 bg-dark dash-card shadow-2xl">
            <b-row>
              <b-col cols="12" class="" >
                <h3 class="text-white">Share</h3> <div class="d-inline">
                   <social-sharing
                  :url="refLink"
                  title="With AGBELOBA, I am able to have a share in the Booming Nigerian Agriculture market. Signup with my link and let’s grow our wealth together 😁 #agriculture #investment #highreturns #guaranteed"
                  description="With AGBELOBA, I am able to have a share in the Booming Nigerian Agriculture market. Signup with my link and let’s grow our wealth together 😁 #agriculture #investment #highreturns #guaranteed"
                  quote="With AGBELOBA, I am able to have a share in the Booming Nigerian Agriculture market.Signup with my link and let’s grow our wealth together 😁 #agriculture #investment #highreturns #guaranteed"
                  twitter-user="agbeloba_ng"
                  inline-template
                >
                  <div>
                    <network
                      class="d-inline-block mb-2"
                      network="facebook"
                    >
                        <b-button size="sm">
                          <i class="text-light fab fa-facebook"></i>
                        </b-button>
                    </network>
                    <network
                      class="d-inline-block  mb-2"
                      network="twitter"
                    >
                        <b-button size="sm">
                          <i class="text-light fab fa-twitter "></i>
                        </b-button>
                    </network>
                    <network
                      class="d-inline-block  mb-2"
                      network="whatsapp"
                    >
                        <b-button size="sm">
                          <i class="text-light fab fa-whatsapp"></i>
                        </b-button>
                    </network>
                    <network
                      class="d-inline-block  mb-2"
                      network="linkedin"
                    >
                        <b-button size="sm">
                          <i class="text-light fab fa-linkedin"></i>
                        </b-button>
                    </network>
                  </div>
                </social-sharing>
                </div>
                <p class="text-white">
                  Share your referral link or code to people. Remember, you earn 5% for every one you
                  refer
                </p>
                <b-input-group>
                  <b-form-input
                    id="ref-link2"
                    type="text"
                    :value="refLink"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button variant="secondary" @click="handleCopyLink"
                      >Copy</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col cols="12">
               
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12"  class="mb-4" style="margin-top:-50px;">
          <div class="wrapper bg-white dash-card px-4 pt-5 pb-2">
            <b-row align-v="stretch" class="text-center h-100">
              <b-col cols class="mb-2">
                <div
                  class="wrapper bg-light p-3 dash-card h-100 d-flex align-items-center"
                >
                  <div class="inner text-center w-100">
                    <Money :value="data.totalCommission" />
                    <small class="text-muted">Rewards Earned</small>
                  </div>
                </div>
              </b-col>
              <b-col cols class="mb-2">
                <div
                  class="wrapper bg-light p-3 dash-card h-100 d-flex align-items-center"
                >
                  <div class="inner text-center w-100">
                    <h4 class="m-0">{{ data.noOfReferrals }}</h4>
                    <small class="text-muted">
                      {{ userObj.is_stakeholder ? "Direct" : "Total" }}
                      Referrals
                    </small>
                  </div>
                </div>
              </b-col>
              <b-col cols class="mb-2" v-if="userObj.is_stakeholder == true">
                <div
                  class="wrapper bg-light p-3 dash-card h-100 d-flex align-items-center"
                >
                  <div class="inner w-100 text-center">
                    <h4 class="m-0">{{ data.noOfIndirectReferrals }}</h4>
                    <small class="text-muted">Indirect Referrals</small>
                  </div>
                </div>
              </b-col>
              <b-col cols class="mb-2">
                <div
                  class="wrapper bg-light p-3 dash-card h-100 d-flex align-items-center"
                >
                  <div class="inner w-100 text-center">
                    <h4 class="m-0">{{ data.noOfPotentialInvestors }}</h4>
                    <small class="text-muted">Potential investors</small>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="mt-5">
            <h5 class="font-weight-normal">People You Referred</h5>
            <ReferralsTable />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageTitle from "@/components/ui/PageTitle";
import ReferralsTable from "./components/ReferralsTable";
import { UserService } from "@/services";

export default {
  data() {
    return {
      data: {}
    };
  },
  components: {
    PageTitle,
    ReferralsTable
  },
  computed: {
    ...mapState(["userObj"]),
    refLink() {
      return `https://app.agbeloba.ng/r/${this.userObj.referralcode}/`;
    }
  },
  methods: {
    handleCopyLink() {
      var copyText = document.getElementById("ref-link2");

      /* Select the text field */
      copyText.disabled = false;
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");
      copyText.disabled = true;

      /* Alert the copied text */
      this.$store.dispatch("toast", {
        message: "Copied successfully"
      });
    }
  },
  created() {
    const data = this.$route.meta.__data;
    this.data = data;
  },
  async beforeRouteEnter(to, from, next) {
    // const completeProfile = store.state["userObj"].eventcode;
    // if (!completeProfile) {
    //   next("dashboard");
    // }

    const { data } = await UserService.getReferralData();
    to.meta.__data = data;
    next();
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  #ref-link2 {
    padding: 0.4em;
  }
  
}
</style>
